const isValidObjectId = (id) => {
  return /^[a-fA-F0-9]{24}$/.test(id);
};

const getCurrentId = (location, raw) => {
  try {
    const parts = location.pathname.split('/').filter(Boolean);
    if (raw) return parts[parts.length - 1];
    for (let i = parts.length - 1; i >= 0; i--) {
      if (isValidObjectId(parts[i])) return parts[i];
    }
    return null;
  } catch {
    return null;
  }
};

export default getCurrentId;
